import { useTranslation } from 'react-i18next';
import { useStaffOnlyLogic } from '../../hooks/useStaffOnlyLogic';
import { StaffOnlyFilterForm } from '../elements/StaffOnlyFilterForm';
import { StaffOnlySearchForm } from '../elements/StaffOnlySearchForm';
import { StaffOnlySidebar } from '../elements/StaffOnlySidebar';
import { StaffOnlySpaceTypeSelector } from '../elements/StaffOnlySpaceTypeSelector';
import { StaffLayout } from '../layouts/StaffLayout';

export const StaffOnly = () => {
  const { t } = useTranslation();

  const {
    register,
    setValue,
    selectedSpaceType,
    selectedAirport,
    selectedFlightType,
    selectedTerminal,
    selectedLounge,
    selectedDate,
    startsAtHour,
    startsAtMinute,
    endsAtHour,
    endsAtMinute,
    airports,
    allTerminals,
    allLounges,
    isLoadingAirports,
    isLoadingAllTerminals,
    isLoadingAllLounges,
    areaError,
    searchError,
    handleSearch,
    handleReset,
    onChangeSpaceType,
    hasTimeParams,
  } = useStaffOnlyLogic();

  const sidebar = (
    <StaffOnlySidebar
      mode="search"
      onSearch={handleSearch}
      onReset={handleReset}
      selectedSpaceType={selectedSpaceType}
    />
  );

  return (
    <StaffLayout sidebar={sidebar}>
      <div className="e__line">
        <div className="e__inner">
          <div className="e__area">
            <form
              className="e__form e-search"
              id="reservation-search-form"
              noValidate
            >
              {/* スペースタイプセレクター */}
              <StaffOnlySpaceTypeSelector
                selectedSpaceType={selectedSpaceType}
                onSelectShower={() => onChangeSpaceType('shower_room')}
                onSelectPrivateRoom={() => onChangeSpaceType('private_room')}
              />

              {/* 検索フォーム */}
              <StaffOnlySearchForm
                register={register}
                isDisabled={!selectedSpaceType}
              />

              {/* フィルターフォーム（動的ドロップダウン） */}
              <StaffOnlyFilterForm
                register={register}
                setValue={setValue}
                airports={airports}
                terminals={allTerminals}
                lounges={allLounges}
                isLoadingAirports={isLoadingAirports}
                isLoadingTerminals={isLoadingAllTerminals}
                isLoadingLounges={isLoadingAllLounges}
                selectedAirport={selectedAirport}
                selectedFlightType={selectedFlightType}
                selectedTerminal={selectedTerminal}
                selectedLounge={selectedLounge}
                selectedSpaceType={selectedSpaceType}
                selectedDate={selectedDate}
                startsAtHour={startsAtHour}
                startsAtMinute={startsAtMinute}
                endsAtHour={endsAtHour}
                endsAtMinute={endsAtMinute}
                defaultTimeExpanded={hasTimeParams}
              />

              {/* エラー表示（エリア取得） */}
              {areaError && (
                <div className="e__alert e__alert--error">
                  {t('staffOnly.errors.areaFetchError')}: {areaError}
                </div>
              )}

              {/* エラー表示（検索） */}
              {searchError && (
                <div className="e__alert e__alert--error">{searchError}</div>
              )}
            </form>
          </div>
        </div>
      </div>
    </StaffLayout>
  );
};
